<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "InputVatId" });
import { InputText } from "../../../../inputs/index.js";
import { VAT_CONFIG } from "./config.js";
export let value;
export let placeholder = "VAT ID";
export let label = "VAT ID";
export let isDisabled = false;
export let isReadonly = false;
export let isRequired = false;
export let countryCode = void 0;
let hint = void 0;
let pattern = void 0;
const countryCodeChanged = (code) => {
    if (code === void 0) {
        hint = void 0;
        pattern = void 0;
        return;
    }
    if (code in VAT_CONFIG) {
        const { hint: NEW_HINT, pattern: NEW_PATTERN } = VAT_CONFIG[code];
        hint = NEW_HINT;
        pattern = NEW_PATTERN;
    }
};
$: value = value?.replace(/\s+/ug, "");
$: countryCodeChanged(countryCode);
</script>

<InputText
    { hint }
    { isDisabled }
    { isReadonly }
    { isRequired }
    { label }
    { pattern }
    { placeholder }
    bind:value
    name = 'organization.vat_id'
/>